import React from "react";
import { SkeletonLoader } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

const StepLoader = ({ className }) => {
  return (
    <div className={classNames("tw-flex tw-flex-col tw-gap-4", className)}>
      <SkeletonLoader className="tw-h-6 tw-w-full" />
      <SkeletonLoader className="tw-h-6 tw-w-full" />
      <SkeletonLoader className="tw-h-6 tw-w-full" />
      <SkeletonLoader className="tw-h-6 tw-w-full" />
    </div>
  );
};

StepLoader.propTypes = {
  className: PropTypes.string,
};

export default StepLoader;
